import z from "zod";

const baseErrorTypeValues = ["EXTERNAL_SERVICE_ERROR_DO_NOT_LOG", "ABORT_ROUTE_CHANGE"] as const;

const baseErrorTypeSchema = z.enum(baseErrorTypeValues);
export const BaseErrorType = baseErrorTypeSchema.enum;
export type BaseErrorType = z.infer<typeof baseErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type BaseErrors =
  | {
      errorType: typeof BaseErrorType.EXTERNAL_SERVICE_ERROR_DO_NOT_LOG;
      data: undefined;
    }
  | {
      errorType: typeof BaseErrorType.ABORT_ROUTE_CHANGE;
      data: { url: string };
    };

export const baseErrorDetails: Record<BaseErrorType, ErrorDetails> = {
  [BaseErrorType.EXTERNAL_SERVICE_ERROR_DO_NOT_LOG]: {
    sentryDescription: "External service error",
  },
  [BaseErrorType.ABORT_ROUTE_CHANGE]: {
    sentryDescription: "Abort route change by user's confirmation.",
  },
};
